import React, { Component } from 'react'
import { observer } from 'mobx-react'

@observer
class QuestionOption extends Component {
    constructor(props) {
        super(props)

        this.state = {
            open: false,
            updated: new Date(),
        }
    }

    toggle = () => {
        this.setState(({ open }) => ({ open: !open }))
    }

    renderOption = (label, id, option, questionTypeCode) => {
        const { ruleGroup, addRuleOption } = this.props
        const isDisabled = ruleGroup.hasRule(option.id)
        const background = isDisabled ? '#FEFEFE' : '#FFF'
        const color = isDisabled ? '#BEC6CE' : undefined

        return (
            <div
                key={option.id}
                className="question_option"
                style={{ background, color, cursor: 'pointer' }}
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (!isDisabled) {
                        addRuleOption(label, id, option, questionTypeCode)
                    }
                    this.setState({ updated: new Date() })
                }}
            >
                {option.label}
            </div>
        )
    }

    pageQuestions = () => {
        const { open } = this.state
        const { option } = this.props
        const { pageQuestions } = option

        if (!open || pageQuestions.length === 0) return null

        return (
            <div className="sub-filter">
                {pageQuestions.map(({
                    label, id, options, questionTypeCode,
                }) => (
                    <div
                        key={id}
                        style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <span>{label}</span>
                        <br />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {options.map((opt) => this.renderOption(label, id, opt, questionTypeCode))}
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    render() {
        const { option } = this.props
        const { open } = this.state

        const chevron = open ? 'fa-light fa-chevron-up' : 'fa-light fa-chevron-down'

        return (
            <div className="report-filter" onClick={this.toggle}>
                <div className="accordion">
                    <i className={chevron} />
                    <span>{option.title}</span>
                    {option.description && (
                        <span className="description">{option.description}</span>
                    )}
                </div>
                {this.pageQuestions()}
            </div>
        )
    }
}

export default QuestionOption
